const features = [
  {
    id: 1,
    title: "想批發但怕沒經驗",
    content:
      "這裡有完整的SOP及導師帶領，就算妳對認購或數位資產完全不懂，也能從第一步開始穩定獲利。",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20cute%20graduation%20cap%20with%20a%20small%20diploma%20scroll%20and%20a%20checkmark%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=14&orientation=squarish",
    color: "bg-amber-50",
    border: "border-amber-100",
    text: "text-amber-700",
  },
  {
    id: 2,
    title: "不想再被高額抽成壓垮",
    content:
      "傳統電商扣掉手續費和運費就沒剩多少。我們幫妳省下囤貨成本，讓每一分賺到的錢都實實在在進妳口袋。",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20an%20empty%20warehouse%20with%20a%20single%20small%20box%20and%20a%20green%20checkmark%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=15&orientation=squarish",
    color: "bg-emerald-50",
    border: "border-emerald-100",
    text: "text-emerald-700",
  },
  {
    id: 3,
    title: "想要更簡單、透明的後台",
    content:
      "不需要被固定的場所或時間綁架，只要透過手機，就能輕鬆參與全球優質產品的認購批發，結合數位資產的高流動性，讓妳隨時隨地都能掌握商品動態，享受真正自由、高效的銷售體驗",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20small%20dashboard%20screen%20with%20bar%20chart%20and%20pie%20chart%20floating%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=16&orientation=squarish",
    color: "bg-sky-50",
    border: "border-sky-100",
    text: "text-sky-700",
  },
  {
    id: 4,
    title: "一鍵參與認購，打破空間限制",
    content:
      "不需要被固定的場所或時間綁架，只要透過手機，就能輕鬆參與全球優質產品的認購批發，結合數位資產的高流動性，讓妳隨時隨地都能掌握商品動態，享受真正自由、高效的銷售體驗",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20smartphone%20with%20a%20small%20shopping%20cart%20and%20notification%20bell%20floating%20above%20it%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=17&orientation=squarish",
    color: "bg-rose-50",
    border: "border-rose-100",
    text: "text-rose-700",
  },
  {
    id: 5,
    title: "讓資金不再只是躺在銀行",
    content:
      "讓資金不再只是躺在銀行：聰明的人會讓錢自己滾動。透過我們的媒合佈局， 讓妳在忙碌的生活中，還能額外擁有一份持續增長的收入",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20small%20piggy%20bank%20with%20coins%20dropping%20into%20it%20and%20a%20small%20upward%20arrow%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=18&orientation=squarish",
    color: "bg-violet-50",
    border: "border-violet-100",
    text: "text-violet-700",
  },
];

function MarqueeCard({ f }: { f: (typeof features)[0] }) {
  return (
    <div className="flex-shrink-0 w-[380px] sm:w-[420px] flex items-start gap-3">
      {/* 頭像 / 圖標 */}
      <div className="w-12 h-12 rounded-full overflow-hidden bg-white ring-2 ring-white shadow-md flex-shrink-0 mt-2">
        <img src={f.image} alt={f.title} className="w-full h-full object-cover" />
      </div>

      {/* 對話泡泡 */}
      <div className={`relative ${f.color} ${f.border} border rounded-[2rem] rounded-tl-md px-6 py-5 flex flex-col gap-2`}>
        {/* 小三角：指向左邊頭像 */}
        <div className={`absolute -left-[6px] top-4 w-3 h-3 ${f.color} border-l ${f.border} border-b ${f.border} rotate-45`} />

        <h4 className="text-gray-900 font-semibold text-base leading-snug">
          {f.title}
        </h4>
        <p className="text-gray-500 text-sm leading-relaxed">{f.content}</p>
      </div>
    </div>
  );
}

export default function TestimonialSection() {
  const allCards = [...features, ...features];

  return (
    <section className="py-16 bg-amber-50/50 overflow-hidden">
      <div className="text-center mb-10 px-6">
        <span className="inline-block bg-amber-100 text-amber-700 text-xs font-semibold px-3 py-1 rounded-full mb-3">
          最新趨勢國際認購
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          找到對的模式，讓賺錢變得不再辛苦
        </h2>
        <p className="text-gray-500 text-sm mt-2">
          最新趨勢國際認購，把複雜的流程變簡單，新手也能輕鬆上手
        </p>
      </div>

      {/* Marquee track */}
      <div className="relative group">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-amber-50/50 to-transparent z-10 pointer-events-none" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-amber-50/50 to-transparent z-10 pointer-events-none" />

        <div className="flex gap-6 animate-marquee group-hover:[animation-play-state:paused]">
          {allCards.map((f, idx) => (
            <MarqueeCard key={`${f.id}-${idx}`} f={f} />
          ))}
        </div>
      </div>
    </section>
  );
}